import React from 'react';
import Wrapper from './Wrapper.jsx';
import ReactMarkdown from 'react-markdown';
import remarkBreaks from 'remark-breaks';
import rehypeRaw from 'rehype-raw';
import rehypeSanitize from 'rehype-sanitize';

const MarkdownViewer = (props) => {
	const { value } = props;

	// Ensure value is a string and handle edge cases
	console.log('value', value);
	const markdownValue = typeof value === 'string' ? value : String(value || '');

	return (
		<Wrapper {...props}>
			{/*
			  Intigriti DS53NYJI: rehypeRaw renders embedded raw HTML (e.g. welcomeMessage),
			  which allowed injected <script>/<iframe srcdoc> to execute. rehypeSanitize runs
			  after rehypeRaw to strip scripts, event handlers and other dangerous markup while
			  keeping standard formatting.
			*/}
			<ReactMarkdown
        linkTarget="_blank" 
				remarkPlugins={[remarkBreaks]}
				rehypePlugins={[rehypeRaw, rehypeSanitize]}
			>
				{markdownValue}
			</ReactMarkdown>
		</Wrapper>
	);
};

MarkdownViewer.type = 'Markdown';
MarkdownViewer.spec = [
	{
		name: 'Markdown',
		key: 'Markdown',
		icon: 'Hash',
		title: 'Markdown article',
		category: 'layout',
		translatable: ['markdown'],
		fields: [
			{
				type: 'MarkdownEditor',
				name: 'markdown',
			},
		],
	},
];
export default MarkdownViewer;
